import { useState, useEffect } from 'react';
import { getApiBaseUrl } from '../lib/apiBase';

const API_BASE_URL = getApiBaseUrl();

export function useJobs(supabase, session) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchJobs = () => {
    setLoading(true);
    fetch(`${API_BASE_URL}/api/jobs`)
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Jobs API failed (${res.status}): ${text.slice(0, 80)}`);
        }
        return res.json();
      })
      .then(data => {
        setJobs(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(err => {
        console.error('Fetch error:', err);
        setJobs([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  const handleDeleteJob = async (jobId) => {
    if (window.confirm('Are you sure you want to delete this job posting?')) {
      try {
        const res = await fetch(`${API_BASE_URL}/api/jobs/${jobId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${session?.access_token}`
          }
        });
        if (res.ok) {
          setJobs(jobs.filter(j => j.id !== jobId));
          alert('Job deleted successfully');
        } else {
          alert('Failed to delete job');
        }
      } catch (err) {
        alert('Error deleting job: ' + err.message);
      }
    }
  };

  const handleToggleJobStatus = async (job) => {
    const newStatus = job.status === 'active' ? 'inactive' : 'active';
    try {
      const { error } = await supabase
        .from('jobs')
        .update({ status: newStatus })
        .eq('id', job.id);

      if (error) throw error;
      setJobs(jobs.map(j => j.id === job.id ? { ...j, status: newStatus } : j));
    } catch (err) {
      alert('Error updating job status: ' + err.message);
    }
  };

  const onJobPosted = (newJob, editingJob) => {
    const currentJobs = Array.isArray(jobs) ? jobs : [];
    let updatedJobs = editingJob 
      ? currentJobs.map(j => j.id === editingJob.id ? newJob : j) 
      : [newJob, ...currentJobs];
    setJobs(updatedJobs);
  };

  return { 
    jobs, 
    loading, 
    handleDeleteJob, 
    handleToggleJobStatus, 
    onJobPosted,
    fetchJobs 
  };
}
